import { render, staticRenderFns } from "./SewageTreatmentWriteBody.vue?vue&type=template&id=90907612&scoped=true"
import script from "./SewageTreatmentWriteBody.vue?vue&type=script&lang=js"
export * from "./SewageTreatmentWriteBody.vue?vue&type=script&lang=js"
import style0 from "./SewageTreatmentWriteBody.vue?vue&type=style&index=0&id=90907612&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90907612",
  null
  
)

export default component.exports